<wuc-balloon arrowPosition="topLeft" padding="medium">
  <ng-content></ng-content>
</wuc-balloon>
